import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/src/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/kalindi.dcpltechnology.com/src/components/layout/index.js");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/src/components/loader/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoaderProvider"] */ "/data/kalindi.dcpltechnology.com/src/contexts/LoaderContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/kalindi.dcpltechnology.com/src/redux/ReduxProvider.js");
